<template>
  <a-tree-select
    allowClear
    labelInValue
    style="width: 100%"
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :placeholder="placeholder"
    :value="treeValue"
    :treeData="treeData"
    :multiple="multiple"
    @change="onChange"
    :tree-checkable="checkable"
  >
  </a-tree-select>
</template>
<script>
/**
 * author 周娇
 * desc 下拉树选择框
 * params:
 *  treeData:下拉数据源
 *  value 初始值
 *  disabled 是否禁用
 *  multiple 是否支持多选
 */
export default {
  name: 'TreeSelect',
  props: {
    treeData: {
      type: Array,
      required: true,
      default: [],
    },
    value: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    checkable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      treeValue: undefined,
    };
  },
  watch: {
    value(val) {
      this.treeValue = val;
    },
  },
  methods: {
    onChange(value) {
      if (!value) {
        this.$emit('change', '');
        this.treeValue = '';
      } else if (value instanceof Array) {
        this.$emit('change', value.map((item) => item.value).join(','));
        this.treeValue = value;
      } else {
        this.$emit('change', value.value);
        this.treeValue = value;
      }
    },
  },
};
</script>
